import * as React from 'react';

import * as styles from './styles.css';

interface IPageLayoutProps {
  navigation: React.ReactNode;
  sidebar: React.ReactNode;
  map: React.ReactNode;
  footer?: React.ReactNode;
  isSidebarOpened?: boolean;
}

export function PageLayout(props: IPageLayoutProps) {
  const { navigation, sidebar, map, footer, isSidebarOpened } = props;
  const navRef = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    const navEl = navRef.current;
    if (!navEl) {
      return undefined;
    }

    const updateNavHeight = () => {
      document.documentElement.style.setProperty('--page-nav-height', `${navEl.offsetHeight}px`);
    };

    updateNavHeight();
    const observer = new ResizeObserver(updateNavHeight);
    observer.observe(navEl);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty('--page-nav-height');
    };
  }, []);

  React.useLayoutEffect(() => {
    const headerEl = document.getElementById('page-header-sticky');
    if (!headerEl) {
      return undefined;
    }

    const updateHeaderHeight = () => {
      document.documentElement.style.setProperty('--page-header-height', `${headerEl.offsetHeight}px`);
    };

    updateHeaderHeight();
    const observer = new ResizeObserver(updateHeaderHeight);
    observer.observe(headerEl);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty('--page-header-height');
    };
  }, []);

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);

    if (isSidebarOpened) {
      document.documentElement.classList.remove('scroll-locked');

      return undefined;
    }

    document.documentElement.classList.add('scroll-locked');

    return () => {
      document.documentElement.classList.remove('scroll-locked');
    };
  }, [isSidebarOpened]);

  return (
    <div className={styles['container']}>
      <div ref={navRef} className={styles['navigation-container']}>
        {navigation}
      </div>
      <div className={styles['content']}>
        <div className={styles['sidebar-slot']}>{sidebar}</div>
        <div className={styles['map-wrapper']}>{map}</div>
      </div>
      <div className={styles['footer']}>{footer}</div>
    </div>
  );
}
